import PropTypes from 'prop-types';
import { noop } from 'lodash';
import React from 'react';
import Relationship from 'facet-rest/src/domain/Relationship';
import { AddCircle } from '@material-ui/icons';
import Button1 from 'Components/ComponentLibrary/Components/Buttons/Button1';
import { FDStack } from '@facet-wealth/design';

function OnboardingAddItemButton({ relationship, onAdd }) {
  if (!relationship) {
    return null;
  }

  return (
    <FDStack justifyContent={'center'}>
      <Button1
        color={'secondary'}
        onClick={() => onAdd(relationship)}
        startIcon={<AddCircle />}
        test={'add-item-button'}
      >
        {relationship.meta('prompt')}
      </Button1>
    </FDStack>
  );
}

OnboardingAddItemButton.propTypes = {
  relationship: PropTypes.instanceOf(Relationship).isRequired,
  onAdd: PropTypes.func,
};

OnboardingAddItemButton.defaultProps = {
  onAdd: noop,
};

export default OnboardingAddItemButton;
